<template>
  <div class="mikan_gari try_pages">
    <div class="title-container">
      <h2 class="container">みかん狩り</h2>
    </div>
    <div class="container py-3">
      <photo-text
        verticalText
        title="みかん狩り"
        text="五月の初旬に花を咲かせるみかんは、<br>
晩秋から冬にかけて大きな実となります。<br><br>
かつうら町のみかん狩りは、<br>例年十月二十日頃～十二月十日頃まで<br>開催されます。<br><br>
それぞれ個性ある農園なので、<br>お好きな園地でお楽しみください。"
        imgSrc="/static/photos/mikan_farm.jpg"
        imgAlt="みかん狩り"
      ></photo-text>
    </div>
    <div class="container">
      <template v-for="item in data">
        <mikan-farm :data="item" :key="item.id"/>
      </template>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MikanFarm from "@/components/MikanFarmListItem.vue";
import PhotoText from "@/components/PhotoAndText.vue";

export default {
  name: "mikan_gari",
  data: function() {
    return {
      data: [
        {
          title: {
            rendered: "井戸端観光園"
          },
          content: {
            rendered:
              "<p>平地にある観光みかん園で、木の高さも低め。<br>お子様でも安心して楽しむことができます。</p>"
          },
          data: {
            main_image: "/static/photos/mikan_farm_idobata.jpg",
            open_period: "下記までお問合せください",
            open_times: "9:00～17:00",
            address: "勝浦町大字星谷",
            tel: "0885-42-1039",
            fax: "なし",
            access: "星谷運動公園より徒歩2分",
            contact: "井戸端観光園",
            site: "なし",
            description: "大人￥800/小人￥500/幼児￥400\n（2019年）"
          }
        },
        {
          title: {
            rendered: "パイロット松下園"
          },
          content: {
            rendered:
              "<p>みかん以外、多くの柿の木があり<br>2つの味覚を同時に楽しむこともできます。</p>"
          },
          data: {
            main_image: "/static/photos/mikan_farm_matsushitaen.jpg",
            open_period: "下記までお問合せください",
            open_times: "9:00～16:00",
            address: "勝浦町大字沼江萩の谷75",
            tel: "090-4503-0016 または 0885-42-3060",
            fax: "なし",
            access: "",
            contact: "パイロット松下園",
            site: "http://matsushitaen.moo.jp/",
            description: "大人￥800/小人￥500/幼児￥400\n（2019年）"
          }
        },
        {
          title: {
            rendered: "勝浦観光（青）園"
          },
          content: {
            rendered:
              "<p>車いすでも大丈夫のバリアフリー対応。<br>事前予約で、園地でカラオケも楽しめる。</p>"
          },
          data: {
            main_image: "/static/photos/mikan_farm_ao.jpg",
            open_period: "下記までお問合せください",
            open_times: "9:00～17:00",
            address: "勝浦町大字沼江",
            tel: "0885-42-3046",
            fax: "なし",
            access: "",
            contact: "勝浦観光（青）園",
            site: "なし",
            description: "大人￥800/小人￥500/幼児￥400\n（2019年）"
          }
        }
      ]
    };
  },
  components: {
    PhotoText,
    MikanFarm
  }
};
</script>

<style scoped>
h2 {
  text-align: left;
  color: white;
}
</style>